import script from "./UpdateEmployeePage.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateEmployeePage.vue?vue&type=script&setup=true&lang=js"

import "./UpdateEmployeePage.vue?vue&type=style&index=0&id=5b0825d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b0825d1"]])

export default __exports__